var render = function () {
  var _vm$sliderStyles;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "timeline"
  }, [_c('input', {
    staticClass: "progress-background icon-video-timeline focusable",
    style: Object.assign({
      background: _vm.volume === 0 || _vm.soundMuted ? '#dddddd' : ("linear-gradient(to right, #6ec8c6 " + (_vm.volume) + "%, #dddddd 5%)")
    }, (_vm$sliderStyles = _vm.sliderStyles) !== null && _vm$sliderStyles !== void 0 ? _vm$sliderStyles : {}),
    attrs: {
      "id": "volume-range-slider",
      "type": "range",
      "role": "progressbar",
      "aria-label": ("Volume level indicator -- " + (_vm.volume) + "%")
    },
    domProps: {
      "value": _vm.soundMuted ? 0 : _vm.volume
    },
    on: {
      "change": function (e) {
        return _vm.updateVolume(+e.target.value);
      }
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }